import { Textarea } from "@/components/ui/textarea";
import { Section, SaveIndicator } from "./fields";

export const NotesSection = ({ form, update, fp = () => ({}) }) => {
  const { state, error } = fp("notes");
  return (
    <Section title="Notes" number="05" fullWidth>
      <div className="md:col-span-3">
        <div className="flex items-center justify-end mb-2 min-h-[16px]">
          <SaveIndicator state={state} fieldKey="notes" />
        </div>
        <Textarea
          data-testid="notes-input"
          value={form.notes || ""}
          onChange={(e) => update({ notes: e.target.value })}
          rows={5}
          placeholder="Any additional detail for the certificate or audit trail…"
          className="border-[#33424f]/30"
        />
        {error && (
          <p data-testid="inline-error-notes" className="mt-1.5 text-[11px] text-[#b30035] font-body">
            {error}
          </p>
        )}
      </div>
    </Section>
  );
};
